import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { Notification, NotificationContent, NotificationPagination } from "@/types/notification"

export type NotificationDropdownState = {
  items: Notification[]
  unreadCount: number
  pagination: NotificationPagination
  error: string | null
}

const notificationDropdownPaginationInitialState: NotificationPagination = {
  pageNumber: 1,
  pageSize: 3,
  totalElements: 0,
  totalPages: 0,
  numberOfElements: 0,
  first: true,
  last: true,
}

export const notificationDropdownInitialState: NotificationDropdownState = {
  items: [],
  unreadCount: 0,
  pagination: notificationDropdownPaginationInitialState,
  error: null,
}

const slice = createSlice({
  name: "notificationDropdown",
  initialState: notificationDropdownInitialState,
  reducers: {
    setNotificationDropdownAction(state, { payload }: PayloadAction<NotificationContent>) {
      state.items = [...payload.items].sort(
        (a, b) => new Date(b.createdAtUtc).getTime() - new Date(a.createdAtUtc).getTime(),
      )
      state.unreadCount = payload.unreadCount
      state.pagination = {
        ...notificationDropdownPaginationInitialState,
        ...payload.pagination,
      }
      state.error = null
    },
    markNotificationDropdownAllReadAction(state) {
      const readAtUtc = new Date().toISOString()
      state.items = state.items.map((item) => ({
        ...item,
        isRead: true,
        readAtUtc: item.readAtUtc ?? readAtUtc,
      }))
      state.unreadCount = 0
    },
    setNotificationDropdownErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload
    },
  },
})

export const {
  markNotificationDropdownAllReadAction,
  setNotificationDropdownAction,
  setNotificationDropdownErrorAction,
} = slice.actions

export default slice.reducer
